import React from "react";
import { VscChromeMinimize, VscCallIncoming } from "react-icons/vsc";
import { defaultChatBotSettings } from "../../consts/settings";
import { useQuery } from "../../helpers/hooks/common-hook";

export default function ChatHeader({ settingsState, chatBotSetting, toggleVoiceMode, onClose }) {
  const query = useQuery();
  const title = chatBotSetting.title || defaultChatBotSettings.title;

  return (
    <header className="chat-header" style={{ backgroundColor: chatBotSetting.headerBackgroundColor, color: chatBotSetting.headerTextColor }}>
      <div className="chat-header-identity">
        <div className="chat-header-avatar">
          <img src={chatBotSetting.logo || defaultChatBotSettings.logo} alt="" />
        </div>
        <div className="min-w-0">
          <h1 className="chat-header-title">{title}</h1>
          <p className="chat-header-subtitle">
            <span className="chat-status-dot" />
            {settingsState.processing ? "Getting ready…" : chatBotSetting.subTitle || "Here to help"}
          </p>
        </div>
      </div>
      <div className="flex items-center gap-1 shrink-0">
        {query.get("test_voice_mode") && (
          <button type="button" onClick={toggleVoiceMode} className="chat-icon-button" aria-label="Start voice chat" title="Start voice chat">
            <VscCallIncoming size={19} />
          </button>
        )}
        {query.get("plugin") && (
          <button type="button" className="chat-icon-button" onClick={onClose} aria-label="Minimize chat" title="Minimize chat">
            <VscChromeMinimize size={20} />
          </button>
        )}
      </div>
    </header>
  );
}
